import { makeStyles } from '@material-ui/core/styles';
import { ICheckoutTheme } from '../../../../../common/theme/ICheckoutTheme';

export type ConfirmationClasses = 'buttonWrapper' | 'button' | 'buttonText' | 'buttonWrapperWithMyAccount';

const goHomeButtonStyles = makeStyles<ICheckoutTheme, ConfirmationClasses>(
  theme => ({
    buttonWrapper: {
      display: 'flex',
      justifyContent: 'center',
      flexGrow: 1,
      margin: `${theme.spacing(2)} 0 ${theme.spacing(4)} 0`,
    },
    buttonWrapperWithMyAccount: {
      flexGrow: 1,
      float: 'right',
      margin: `${theme.spacing(2)} 0 ${theme.spacing(4)} 0`,
    },
    button: {},
    buttonText: {},
  }),
  { name: 'GqlCheckout_ConfirmationGoHome' },
);

export default goHomeButtonStyles;
